module.exports = __webpack_public_path__ + "img/flecha2izq.1b999f8a.png";